export { default } from './Dialog';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Dialog/index.js
// module id = 225
// module chunks = 121